/* ==============================================================================================
 * TOOLTIPSTER HELPER
 *
 * Create Tooltipster instances based on HTML attributes.
 * ============================================================================================== */

var $ = window.jQuery;

(function () {
	"use strict";

	var instances = $("[data-tooltipster]");

	if (instances.length) {
		instances.each(function (index, trigger) {
			var options = {};
			var triggerEl = $(trigger);

			options.maxWidth = $(trigger).attr("data-tooltipster-max-width") || 320;
			options.theme = "tooltipster--" + $(trigger).attr("data-tooltipster-theme") || null;

			if (!triggerEl.hasClass("tooltipstered")) {
				$(trigger).tooltipster(options);
			}
		});
	}

})();
